"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraLogout = void 0;
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const EuraButton_1 = require("./EuraButton");
const EuraModal_1 = require("./EuraModal");
const Icons_1 = require("./Icons");
const EuraLogout = (props) => {
    const [showLogoutModal, setShowLogoutModal] = (0, react_1.useState)(false);
    const { localizations, children, className = 'top-menu-container--logout-container' } = props;
    const logoutHandler = () => (window.location.href = props.logoutUrl);
    const handleModalClick = (event, state) => {
        event.stopPropagation();
        setShowLogoutModal(state);
    };
    const LogoutModal = () => (react_1.default.createElement(EuraModal_1.EuraModal, { title: localizations.title, visible: !!showLogoutModal, closable: true, keyboard: true, onCancel: (e) => handleModalClick(e, false), footer: [
            react_1.default.createElement(antd_1.Row, { key: 'submit', justify: 'space-between' },
                react_1.default.createElement(antd_1.Col, null,
                    react_1.default.createElement(EuraButton_1.EuraButton, { label: localizations.buttonCancel, dataTestId: 'kirjauduUlos.peruuta', onClick: (e) => handleModalClick(e, false) })),
                react_1.default.createElement(antd_1.Col, null,
                    react_1.default.createElement(EuraButton_1.EuraButton, { label: localizations.buttonOk, dataTestId: 'kirjaudu.ulos.button', primary: true, onClick: logoutHandler }))),
        ] },
        react_1.default.createElement("span", { "data-testid": 'kirjauduUlos.modal.msg', style: { whiteSpace: 'pre-wrap' } },
            react_1.default.createElement("div", { className: 'usertable-value', tabIndex: 0 }, localizations.confirmation))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { "aria-label": localizations.title, className: className, "data-testid": 'kirjaudu.ulos.icon', onClick: (e) => handleModalClick(e, true) }, children ? children : react_1.default.createElement(Icons_1.LogoutIcon, null)),
        react_1.default.createElement(LogoutModal, null)));
};
exports.EuraLogout = EuraLogout;
